
<template>
    <div class="pa-2">
      <v-card class="pa-5" >
       
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
            <div>
          <h2>Register Here</h2>
          <p >Please Provide Your Personal Details To Get started</p>
        </div> 

            <FormComponent />
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
            <v-img 
            class="rounded-lg"
            
            :src="image "
            :height="$vuetify.breakpoint.mobile ? '40vh': '60vh'"
            
            ></v-img>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </template>
  
  <script>
import FormComponent from './layouts/FormComponent.vue';
  export default {
  name: 'RegisterComponentView',
  components: { FormComponent },
    data(){
  return{
   image: require('@/assets/garage1.jpg'),
  }
  
}
  }

  </script>
  
  <style  scoped>
 
  </style>
  